import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledGithubSnakeSection = styled.section`
  max-width: 1000px;

  .inner {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .snake-container {
    width: 100%;
    max-width: 800px;
    margin-top: 20px;
    text-align: center;

    a {
      display: block;
      cursor: pointer;

      img {
        width: 100%;
        height: auto;
        border-radius: var(--border-radius);
        background-color: var(--light-navy);
        padding: 20px;
        transition: var(--transition);

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 30px -15px var(--navy-shadow);
        }

        @media (max-width: 768px) {
          padding: 10px;
        }
      }
    }
  }

  .github-link {
    ${({ theme }) => theme.mixins.inlineLink};
    margin-top: 20px;
    font-size: var(--fz-sm);
  }
`;

const GithubSnake = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  return (
    <StyledGithubSnakeSection ref={revealContainer}>
      <h2>Commit Confessions: A History of Questionable Decisions</h2>

      <div className="inner">
        <div className="snake-container">
          <a
            href="https://github.com/vincent-tws"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="View GitHub profile">
            <img
              src="/dist/github-snake-light.svg"
              alt="GitHub contribution snake animation"
              loading="lazy"
            />
          </a>
        </div>
        <a
          href="https://github.com/vincent-tws"
          target="_blank"
          rel="noopener noreferrer"
          className="github-link">
          View on GitHub
        </a>
      </div>
    </StyledGithubSnakeSection>
  );
};

export default GithubSnake;
